import { useField } from "formik";
import { forwardRef } from "react";

const CustomInput = forwardRef(
  (
    {
      label,
      showAstreisk = true,
      className = "",
      layout = "stacked",
      labelWidth = {},
      labelClassName = "",
      type = "text",
      children,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const [field, meta] = useField(props);

    const inputClassName = `custom-primary-input ${className} ${
      meta.touched && meta.error ? "custom-input-error" : ""
    }`.trim();

    const getResponsiveGap = () => {
      return {
        "--label-width-mobile": labelWidth?.mobile || "100px",
        "--label-width-tablet": labelWidth?.tablet || "100px",
        "--label-width-desktop": labelWidth?.desktop || "100px",
      };
    };
    const isNumber = type === "number";

    return (
      <div
        className={`custom-input-group ${
          layout === "inline" ? "inline-layout" : ""
        }`}
        style={layout === "inline" ? getResponsiveGap() : {}}
      >
        <div className="label-container">
          <label className={labelClassName}>
            {label} {showAstreisk && "*"}
          </label>
        </div>

        <div style={{ flex: layout === "inline" ? 1 : "unset" }}>
          {type === "select" ? (
            <select {...field} {...props} ref={ref} className={inputClassName}>
              {children}
            </select>
          ) : (
            <input
              {...field}
              {...props}
              inputMode={isNumber ? "numeric" : undefined}
              type={isNumber ? "text" : type}
              ref={ref}
              className={inputClassName}
              onChange={(e) => {
                if (!isNumber) {
                  field.onChange(e);
                  return;
                }

                // allow only digits
                const value = e.target.value.replace(/[^0-9]/g, "");
                field.onChange({
                  target: { name: field.name, value },
                });
              }}
              disabled={disabled}
            />
          )}

          {meta.touched && meta.error && (
            <div className="custom-error">{meta.error}</div>
          )}
        </div>
      </div>
    );
  },
);

export default CustomInput;
